/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  baseStyle: {
    maxWidth: 'container.xxxl',
    paddingLeft: [4, 4, 6, 8],
    paddingRight: [4, 4, 6, 8],
  },
  variants: {
    form: {
      maxWidth: '522px',
      px: 0,
    },
  },
};
